export default "__VITE_ASSET__CO_qAtN0__"